import { api } from '../../../api/client';

export const auditsApi = {
  /**
   * Obtiene logs de auditoría con filtros opcionales y paginación
   * @param {object} params - { username, module, action, status, startDate, endDate, search, page, size }
   */
    /** Lista todos los roles */
  search: (searchData) =>
    api.get('/audit/logs',searchData),

  // search: (params = {}) => {
  //   const query = new URLSearchParams();
  //   if (Array.isArray(params)) {
  //     params.forEach((item) => {
  //       if (item && item.filter && item.value_filter !== undefined && item.value_filter !== null && item.value_filter !== '') {
  //         query.append(item.filter, item.value_filter);
  //       }
  //     });
  //   } else if (params && typeof params === 'object') {
  //     Object.entries(params).forEach(([key, val]) => {
  //       if (val !== undefined && val !== null && val !== '') {
  //         query.append(key, val);
  //       }
  //     });
  //   }
  //   const qs = query.toString();
  //   return api.get(`/audit/logs${qs ? `?${qs}` : ''}`);
  // },

  /**
   * Obtiene KPIs y métricas consolidadas en tiempo real
   */
  getStats: () => api.get('/audit/stats'),

  /**
   * Obtiene opciones dinámicas para filtros (usuarios, módulos, acciones, estados)
   */
  getFilterOptions: () => api.get('/audit/filters-metadata'),

  /**
   * Obtiene el detalle completo de un registro por ID
   */
  getLogById: (id) => api.get(`/audit/logs/${id}`),

  /**
   * Registra un evento de auditoría
   * @param {object} data
   */
  logout: (data) => api.post('/audit/logs', data)
};
